var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8,1.5H4.2c-1.5,0-2.7,1.2-2.7,2.7v11.7c0,1.5,1.2,2.7,2.7,2.7h11.7c1.5,0,2.7-1.2,2.7-2.7V4.2 C18.5,2.7,17.3,1.5,15.8,1.5z M4.2,3.5h11.7c0.4,0,0.7,0.3,0.7,0.7v2.3h-13V4.2C3.5,3.8,3.8,3.5,4.2,3.5z M3.5,15.8V8.5h3v8H4.2 C3.8,16.5,3.5,16.2,3.5,15.8z M15.8,16.5H8.5v-8h8v7.3C16.5,16.2,16.2,16.5,15.8,16.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.14f3516f9cc8a238d50a3fec34469414.svg";
export { ForwardRef as ReactComponent };